<template>
    <div class="image-container">
        <img :src="url" alt="">
    </div>

</template>
<script>
export default {
    data() {
        return {
            url:''
        };
    },
    computed: {},
    watch: {},
    mounted() {
        this.url = this.$route.query.fileUrl;
    },
    methods: {}
}
</script>